export const SURVEY_MINIMUM_ANSWERS_TO_SHOW_ANONYMOUS = 3
